import { SalesFunnelColumnComponent } from '@app/components/SalesFunnelColumnComponent/SalesFunnelColumnComponent.main';

export { SalesFunnelColumnComponent };
